package com.partejar.app.feature.calendar

import com.russhwolf.settings.Settings
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock

class CalendarSyncPreferences(private val settings: Settings) {
    var enabled: Boolean
        get() = settings.getBoolean("calendar.sync.enabled", false)
        set(value) = settings.putBoolean("calendar.sync.enabled", value)
    var suggestionShown: Boolean
        get() = settings.getBoolean("calendar.sync.suggestion_shown", false)
        set(value) = settings.putBoolean("calendar.sync.suggestion_shown", value)

    fun eventId(key: String): String? = settings.getStringOrNull("calendar.sync.event.$key")
    fun rememberEvent(key: String, id: String) = settings.putString("calendar.sync.event.$key", id)
}

/** Stable keys let a rescheduled meeting update the same device event, even if the API replaces its row. */
fun meetingCalendarKey(workspaceId: Long, patientId: Long): String = "$workspaceId.meeting.$patientId"

class DeviceCalendarSync(
    private val integration: CalendarIntegration,
    private val preferences: CalendarSyncPreferences
) {
    suspend fun save(key: String, event: CalendarEventDraft): CalendarEventSaveResult = mutex.withLock {
        if (!preferences.enabled || integration.getPermissionStatus() != CalendarPermissionStatus.GRANTED) {
            return@withLock CalendarEventSaveResult(CalendarEventSaveStatus.PERMISSION_DENIED)
        }
        integration.saveEvent(event.copy(sourceKey = key), preferences.eventId(key)).also { result ->
            if (result.status == CalendarEventSaveStatus.SAVED && result.eventId != null) {
                preferences.rememberEvent(key, result.eventId)
            }
        }
    }

    private companion object { val mutex = Mutex() }
}
